import { Languages } from './languages';
import { useAuth } from 'features/auth/contexts/auth';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from 'utils/assets';

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth();
  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <img alt="Logo" src={currentUser?.photoUrl ?? toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">{currentUser?.userName}</div>
            <a href="#" className="fw-bold text-muted text-hover-primary fs-7">
              {`User ID: ${currentUser?.userId}`}
            </a>
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <Link to="#" className="menu-link px-5">
          My Profile
        </Link>
      </div>

      <Languages />

      <div className="menu-item px-5 my-1">
        <Link to="#" className="menu-link px-5">
          Account Settings
        </Link>
      </div>

      <div className="menu-item px-5">
        <a onClick={logout} className="menu-link px-5">
          Sign Out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
